import { populateSEO } from "@shared/lib";
import { DomesticVacancyPage, PageData, WidgetsComponent } from "../types";
import { ApiInstance } from "./instance";

const populateMeta = {
  vacancyCard: {
    populate: ["salaryInfo", "platformInfo.defaultPlatformLogo"],
  },
  indexPageMeta: {
    populate: ["emptyScreen"]
  },
  detailPageMeta: {
    populate: ["coverBackground", "salaryInfo"]
  },
}

export class DomesticVacancyPageApi extends ApiInstance {
  constructor(locale = "id-ID") {
    super(locale);
  }

  getDomesticVacancyPageData(): Promise<PageData<DomesticVacancyPage>> {
    const query = {
      populate: {
        contents: {
          on: {
            [WidgetsComponent.CommonHeroSection]: {
              populate: [
                "imageDesktop",
                "imageMobile",
                "backgroundMobile",
                "subtitle.icon",
                "button.color",
                "button.icon",
              ]
            },
            [WidgetsComponent.PopularJobFunctionSection]: {
              populate: [
                "button.color",
                "button.icon",
              ]
            },
            [WidgetsComponent.VacancyCarouselSection]: {
              populate: [
                "moreButton.icon",
                "moreButton.color",
                "vacancyCard",
                "vacancyCard.salaryInfo",
                "vacancyCard.platformInfo",
                "vacancyCard.platformInfo.defaultPlatformLogo",
              ]
            },
            [WidgetsComponent.CommonBentoGridSection]: {
              populate: [
                "button.color",
                "button.icon",
                "grids.cards",
                "grids.cards.subtitle.icon",
                "grids.cards.image",
                "grids.cards.backgroundImage",
                "grids.cards.button.icon",
                "grids.cards.button.color",
              ],
            },
          },
        },
        ...populateSEO,
        ...populateMeta,
      },
    };

    return this._SendWithQuery("/domestic-vacancy-page", query);
  }

  getDomesticVacancyPageDataWithoutContents(): Promise<PageData<DomesticVacancyPage>> {
    const query = {
      populate: {
        ...populateSEO,
        ...populateMeta,
      },
    };

    return this._SendWithQuery("/domestic-vacancy-page", query);
  }
}
